<template>
  <Slide right :closeOnNavigation="true" class="override">
    <router-link class="link" to="/our-services/">
      <span>Our Services</span>
    </router-link>
    <a class="link" href="https://backoffice.bsport.io/login?membership=2906" target="_blank">Booking & Prices</a>
    <router-link class="link" to="/about-us/">
      <span>Jean Wilcox</span>
    </router-link>
    <router-link class="link" to="/contact-us/">
      <span>Contact Me</span>
    </router-link>
    <a class="btn" href="tel:01502457598">01502457598</a>
  </Slide>
</template>

<script>
import { Slide } from 'vue-burger-menu'

export default {
  name: 'mobile-menu',
  components: {
    Slide
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";

.router-link-active,
a:hover:not(.btn) {
  text-decoration: underline;
  text-decoration-color: $clr-theme-red;
  color: $white;
}
</style>

<style lang="scss">
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.override {
  .bm-burger-button {
    position: absolute;
    right: 15px !important;
    top: calc(50% - 15px) !important;
    bottom: 0 !important;
    width: 36px;
    height: 30px;
    cursor: pointer;
    display: block;

    @media screen and (min-width: $lg-breakpoint) {
      display: none;
    }
  }
  .bm-burger-bars {
    background-color: $white !important;
  }
  .line-style {
    position: absolute;
    height: 20%;
    width: 36px;
  }
  .cross-style {
    position: absolute;
    top: 12px;
    right: 2px;
    cursor: pointer;
  }
  .bm-cross {
    background: #bdc3c7;
  }
  .bm-cross-button {
    height: 24px;
    width: 24px;
  }
  .bm-menu {
    height: 100%; /* 100% Full-height */
    width: 0; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 1000; /* Stay on top */
    top: 0;
    left: 0;
    background-color: $clr-theme-black !important;
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; /* Place content 60px from the top */
    transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
    .link, a {
      padding-left: 0;
      font-weight: 700;
      text-transform: uppercase;

    }
    a { font-weight: 600;}

    .btn {
      padding: 9px 27px;
      width: fit-content;
      margin-top: 15px;
      white-space: nowrap !important;
    }
  }

  .bm-overlay {
    background: rgba(0, 0, 0, 0.3);
    z-index: 99999999999999999999999999;
  }
  .bm-item-list {
    margin: 0 0 0 30px;
    font-size: 20px;
  }
  .bm-item-list > * {

    display: flex;
  }
  .bm-item-list > * > span, a {
    font-weight: 600;
    color: $white;
    white-space: nowrap;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MobileMenu.vue